/**
 * hero-slider.js — slider 3 bộ sưu tập ở hero trang chủ (index.html, section .home-hero).
 *
 * Markup: [data-hero] chứa các lớp nền [data-hero-bg], slide [data-hero-slide], thẻ chọn
 * [data-hero-to="i"], đoạn tiến trình [data-hero-seg], số trang [data-hero-current] và nút
 * [data-hero-prev] / [data-hero-next] / [data-hero-pause]. Slide 1 có sẵn .is-active trong
 * markup — không có JS thì hero vẫn đủ, chỉ không chuyển slide.
 *
 * Đổi slide = đổi class; toàn bộ chuyển động là @keyframes trong CSS (_home-hero*.scss):
 *   .is-active  → hiệu ứng vào   .is-leaving → hiệu ứng ra (gỡ sau LEAVE_MS)
 * Tự chạy KHÔNG dùng setInterval: đoạn tiến trình đang chạy là một animation dài
 * --hero-interval, hết animation (animationend) thì sang slide kế. Nhờ vậy dừng/tiếp chỉ là
 * animation-play-state (.is-paused) và thanh tiến trình luôn khớp đúng thời gian còn lại.
 * Dừng khi: rê chuột vào sân khấu hoặc thẻ, focus trong hero, bấm nút dừng, tab bị ẩn.
 * Máy bật "giảm chuyển động": CSS bỏ animation ⇒ không có animationend ⇒ không tự chạy,
 * nút dừng ẩn đi (không có gì để dừng). Parallax theo chuột cũng tắt.
 *
 * A11y (mẫu carousel của WAI-ARIA APG): slide không hiện mang aria-hidden + inert; vùng
 * sân khấu aria-live="off" khi tự chạy, "polite" khi người dùng tự chuyển hoặc đã dừng.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var hero = document.querySelector('[data-hero]');
    if (!hero) return;

    var $$ = function (sel) {
        return [].slice.call(hero.querySelectorAll(sel));
    };
    var slides = $$('[data-hero-slide]');
    var bgs = $$('[data-hero-bg]');
    var cards = $$('[data-hero-card]');
    var selects = $$('[data-hero-to]');
    var segs = $$('[data-hero-seg]');
    var stage = hero.querySelector('[data-hero-stage]');
    var nav = hero.querySelector('[data-hero-nav]');
    var current = hero.querySelector('[data-hero-current]');
    var pauseBtn = hero.querySelector('[data-hero-pause]');
    var total = slides.length;
    if (total < 2) return;

    // Khớp thời gian hiệu ứng ra dài nhất (nền 1,4s) — sớm hơn thì lớp cũ biến mất giữa chừng
    var LEAVE_MS = 1400;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var leaveTimer = null;
    var reasons = { user: false, hover: false, focus: false, hidden: false };
    // Người dùng đã tự chuyển slide một lần thì vùng sân khấu giữ aria-live="polite"
    var liveLocked = false;

    function pad(n) {
        return (n < 10 ? '0' : '') + n;
    }

    function each(list, fn) {
        for (var i = 0; i < list.length; i++) fn(list[i], i);
    }

    function go(target, byUser) {
        var next = (target + total) % total;
        if (next === index) return;
        var prev = index;
        index = next;

        each([slides, bgs], function (list) {
            each(list, function (el, i) {
                el.classList.toggle('is-active', i === next);
                el.classList.toggle('is-leaving', i === prev);
            });
        });
        each(slides, function (slide, i) {
            if (i === next) {
                slide.removeAttribute('aria-hidden');
                slide.removeAttribute('inert');
            } else {
                slide.setAttribute('aria-hidden', 'true');
                slide.setAttribute('inert', '');
            }
        });
        each(cards, function (card, i) {
            card.classList.toggle('is-active', i === next);
        });
        each(selects, function (btn, i) {
            if (i === next) btn.setAttribute('aria-current', 'true');
            else btn.removeAttribute('aria-current');
        });
        // Đoạn trước slide hiện tại đầy, đoạn hiện tại chạy lại từ đầu, đoạn sau rỗng
        each(segs, function (seg, i) {
            seg.classList.toggle('is-done', i < next);
            seg.classList.toggle('is-active', i === next);
        });

        if (current) {
            current.textContent = pad(next + 1);
            // Gỡ rồi gắn lại class trong cùng khung hình thì animation không chạy lại —
            // đọc offsetWidth ép trình duyệt tính lại style ở giữa
            current.classList.remove('is-rolling');
            void current.offsetWidth;
            current.classList.add('is-rolling');
        }

        // Thẻ đang chọn luôn nằm trong khung cuộn ngang (mobile)
        var card = cards[next];
        if (card && card.parentNode.scrollWidth > card.parentNode.clientWidth) {
            card.parentNode.scrollTo({
                left: card.offsetLeft - card.parentNode.offsetLeft - 16,
                behavior: reduce.matches ? 'auto' : 'smooth'
            });
        }

        window.clearTimeout(leaveTimer);
        leaveTimer = window.setTimeout(function () {
            each([slides, bgs], function (list) {
                each(list, function (el) {
                    el.classList.remove('is-leaving');
                });
            });
        }, LEAVE_MS);

        if (byUser) {
            liveLocked = true;
            syncLive();
        }
    }

    // ----- Tự chạy / dừng -----
    function isPaused() {
        return reasons.user || reasons.hover || reasons.focus || reasons.hidden;
    }

    function syncLive() {
        if (stage) stage.setAttribute('aria-live', liveLocked || isPaused() ? 'polite' : 'off');
    }

    function syncPause() {
        hero.classList.toggle('is-paused', isPaused());
        syncLive();
    }

    hero.addEventListener('animationend', function (event) {
        if (event.animationName !== 'hero-progress') return;
        if (!event.target.parentNode.classList.contains('is-active')) return;
        go(index + 1, false);
    });

    function setUserPaused(on) {
        reasons.user = on;
        if (pauseBtn) {
            pauseBtn.setAttribute('aria-label', on ? 'Tiếp tục trình chiếu' : 'Tạm dừng trình chiếu');
            var icon = pauseBtn.querySelector('i');
            if (icon) icon.className = 'ph-bold ' + (on ? 'ph-play' : 'ph-pause');
        }
        syncPause();
    }

    function syncMotion() {
        if (pauseBtn) pauseBtn.hidden = reduce.matches;
    }
    syncMotion();
    if (reduce.addEventListener) reduce.addEventListener('change', syncMotion);

    // ----- Điều khiển -----
    function userGo(target) {
        go(target, true);
    }

    hero.addEventListener('click', function (event) {
        var t = event.target.closest ? event.target : null;
        if (!t) return;
        var to = t.closest('[data-hero-to]');
        if (to) return userGo(parseInt(to.getAttribute('data-hero-to'), 10));
        if (t.closest('[data-hero-prev]')) return userGo(index - 1);
        if (t.closest('[data-hero-next]')) return userGo(index + 1);
        if (t.closest('[data-hero-pause]')) setUserPaused(!reasons.user);
    });

    // ← → khi đang focus trong khu điều hướng
    if (nav) {
        nav.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowLeft') userGo(index - 1);
            else if (event.key === 'ArrowRight') userGo(index + 1);
        });
    }

    [stage, nav].forEach(function (zone) {
        if (!zone) return;
        zone.addEventListener('mouseenter', function () {
            reasons.hover = true;
            syncPause();
        });
        zone.addEventListener('mouseleave', function () {
            reasons.hover = false;
            syncPause();
        });
    });

    hero.addEventListener('focusin', function () {
        reasons.focus = true;
        syncPause();
    });
    hero.addEventListener('focusout', function (event) {
        if (event.relatedTarget && hero.contains(event.relatedTarget)) return;
        reasons.focus = false;
        syncPause();
    });

    document.addEventListener('visibilitychange', function () {
        reasons.hidden = document.hidden;
        syncPause();
    });

    // Vuốt ngang trên sân khấu (cảm ứng)
    if (stage) {
        var startX = null;
        var startY = null;
        stage.addEventListener(
            'touchstart',
            function (event) {
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
            },
            { passive: true }
        );
        stage.addEventListener('touchend', function (event) {
            if (startX === null) return;
            var dx = event.changedTouches[0].clientX - startX;
            var dy = event.changedTouches[0].clientY - startY;
            startX = null;
            // Chỉ nhận cú vuốt chủ yếu theo chiều ngang, tránh nhầm với cuộn trang
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) userGo(index + (dx < 0 ? 1 : -1));
        });
    }

    // ----- Parallax theo chuột (chỉ chuột thật, không giảm chuyển động) -----
    // Đặt --hx / --hy (−1…1) trên hero; CSS nhân với --depth của từng lớp. Nội suy dần về
    // đích mỗi khung hình nên chuyển động trôi, không giật theo từng sự kiện chuột.
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var target = { x: 0, y: 0 };
    var pos = { x: 0, y: 0 };
    var frame = null;

    function tick() {
        pos.x += (target.x - pos.x) * 0.08;
        pos.y += (target.y - pos.y) * 0.08;
        hero.style.setProperty('--hx', pos.x.toFixed(3));
        hero.style.setProperty('--hy', pos.y.toFixed(3));
        if (Math.abs(target.x - pos.x) > 0.001 || Math.abs(target.y - pos.y) > 0.001) {
            frame = window.requestAnimationFrame(tick);
        } else {
            frame = null;
        }
    }

    function aim(x, y) {
        target.x = x;
        target.y = y;
        if (!frame) frame = window.requestAnimationFrame(tick);
    }

    hero.addEventListener('mousemove', function (event) {
        if (!fine.matches || reduce.matches) return;
        var rect = hero.getBoundingClientRect();
        aim(((event.clientX - rect.left) / rect.width) * 2 - 1, ((event.clientY - rect.top) / rect.height) * 2 - 1);
    });
    hero.addEventListener('mouseleave', function () {
        aim(0, 0);
    });
})();
